module.exports = __webpack_public_path__ + "static/media/se.fabe0b69.svg";